import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    height: "90%",
    marginTop: "0px",
  },
  listContainer: {
    border: "1px solid #000000",
    borderRadius: "5px",
    height: "94%",
  },
  listItemBtn: {
    borderBottom: "1px solid black",
    transition: "none !important",
    "&:hover": {
      backgroundColor: "#BBBBBB",
    },
  },
  listItmBtnSelected: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#D9D9D9",
    },
  },
  sublistItmBtnSelected: {
    backgroundColor: "#BBBBBB",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#D9D9D9",
    },
  },
  listIcon: {
    minWidth: "45px",
  },
  tableHead: {
    borderBottom: "1px solid white",
  },
  tableRowHeadService: {
    width: "20%",
    padding: "8px",
  },
  tableRowCells: {
    fontSize: "16px",
  },
  tableRowCellsColor: {
    color: "#666666",
  },
  tableRowHeadInvitation: {
    width: "25%",
  },
  centerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
